import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST: createSagaAction(
    'FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST'
  ),
  FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT: createSagaAction(
    'FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT'
  )
}

// Action Creators
export const actions = {
  financialSchedulesReportGetJobList: ({ filters }) => ({
    type: constants.FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  financialSchedulesReportGetFullReport: ({ filters }) => ({
    type: constants.FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.FINANCIAL_SCHEDULES_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.FINANCIAL_SCHEDULES_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/jobs/financialSchedulesReportActions.js